// Transcripts as one card per assistant turn: stores keep each tool call as a message of its own (and a cell's
// transcript each tool output too), so a turn of ten shell commands reads as ten cards. Tool outputs join the call
// they answer, and an assistant message with only tool calls joins the assistant message before it. Text never
// moves: a message with text starts a card.
type Msg = { role?: string; text?: string; tool_calls?: unknown[]; results?: unknown[] }

export function compact<T extends Msg>(messages: T[]): T[] {
  const out: T[] = []
  for (const m of messages) {
    const prev = out[out.length - 1]
    const asst = (x?: Msg) => !!x && (x.role || 'assistant') === 'assistant'
    const calls = (x?: Msg) => (x?.tool_calls || []).length
    const results = (x?: Msg) => (x?.results || []).length
    if (m.role === 'tool_result' && asst(prev) && calls(prev) > results(prev)) {
      out[out.length - 1] = { ...prev!, results: [...(prev!.results || []), ...(m.results || [])] }
    } else if (asst(m) && !String(m.text || '').trim() && calls(m) && asst(prev) && calls(prev) === results(prev)) {
      out[out.length - 1] = { ...prev!, tool_calls: [...(prev!.tool_calls || []), ...(m.tool_calls || [])],
        results: [...(prev!.results || []), ...(m.results || [])] }
    } else {
      out.push(m)
    }
  }
  return out
}
